<template>
  <div class="facility-container">
    <div class="facility-title">为您找到以下设施：</div>
    <div class="facility-list">
      <div v-for="(item, idx) in facilities" :key="idx" class="facility-card" @click="startNavigation(item)">
        <div class="facility-icon">
          {{ getIcon(item.type) }}
        </div>
        <div class="facility-info">
          <div class="facility-name">{{ item.type }}</div>
          <div class="facility-location">{{ item.position || (item.floor + '层') }}</div>
        </div>
        <div class="nav-action">
          <span class="nav-icon">📍</span>
          <span class="nav-text">去这里</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacilityList',
  props: {
    facilities: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['navigate'],
  methods: {
    getIcon(type) {
      if (!type) return '📍';
      if (type.includes('洗手间') || type.includes('卫生间')) return '🚻';
      if (type.includes('母婴')) return '👶';
      if (type.includes('电梯')) return '🛗';
      if (type.includes('服务台')) return '💁‍♀️';
      return '📍';
    },
    startNavigation(item) {
      this.$emit('navigate', {
        name: item.type,
        floor_id: parseInt(item.map_floor),
        x: parseFloat(item.map_x),
        y: parseFloat(item.map_y)
      });
    }
  }
}
</script>

<style scoped>
.facility-container {
  margin-top: 1vh;
  width: 100%;
}

.facility-title {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 1vh;
  font-weight: bold;
}

.facility-list {
  display: flex;
  flex-direction: column;
  gap: 1vh;
}

.facility-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 1vh;
  border-radius: 1vh;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid rgba(0,0,0,0.02);
}

.facility-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.facility-icon {
  width: 5vh;
  height: 5vh;
  border-radius: 50%;
  background: #f0f2f5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  margin-right: 1.5vh;
  flex-shrink: 0;
}

.facility-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.facility-name {
  font-size: 0.95rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 0.3vh;
}

.facility-location {
  font-size: 0.8rem;
  color: #999;
}

.nav-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #d14d5e 0%, #d65db1 100%);
  color: #fff;
  padding: 0.5vh 1.5vh;
  border-radius: 2vh;
  font-size: 0.75rem;
  margin-left: 1vh;
  box-shadow: 0 2px 6px rgba(209, 77, 94, 0.2);
}

.nav-icon {
  font-size: 0.9rem;
  margin-bottom: 0.2vh;
}

.nav-text {
  font-weight: bold;
}
</style>